import React from 'react'
import { FaGithubAlt, FaFacebookSquare, FaLinkedin, FaDev, FaReddit } from 'react-icons/fa'
import '../css/Footer.css'

const Footer = () => {
    return (
        <div className="footerContainer">
            <ul className="footerIconContainer">
                <li className="footerIcon">
                    <a rel="noreferrer" href="https://github.com/sajjathossain/" target="_blank" className="footerLink">
                        <FaGithubAlt />
                    </a>
                </li>
                <li className="footerIcon">
                    <a rel="noreferrer" href="https://www.linkedin.com/in/sajjat-hossain-6477731ab/" target="_blank" className="footerLink">
                        <FaLinkedin />
                    </a>
                </li>
                <li className="footerIcon">
                    <a rel="noreferrer" href="https://dev.to/sajjathossain" target="_blank" className="footerLink">
                        <FaDev />
                    </a>
                </li>
                <li className="footerIcon">
                    <a rel="noreferrer" href="https://www.reddit.com/user/SHProvel" target="_blank" className="footerLink">
                        <FaReddit />
                    </a>
                </li>
                <li className="footerIcon">
                    <a rel="noreferrer" href="https://facebook.com/sajjat.hossain.official.account/" target="_blank" className="footerLink">
                        <FaFacebookSquare />
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default Footer
